export default {
    computed: {
        widget: function () {
            return this.$store.getters.getWidget(this.id);
        },
    },
    methods: {
        destroy: function (force) {
            if (force === true || confirm(this.$i18n.t('confirm_delete_element'))) {
                if (this.id > 1) {
                    this.$store.dispatch('deleteWidget', this.widget);
                } else {
                    this.$store.commit('REMOVE_WIDGET', this.widget)
                }
            }
        },
        save: function () {
            this.beforeSaveCallback && this.beforeSaveCallback();

            if (!this.contents) {
                console.error('No contents! Nothing to save!');
                return;
            }

            this.$store.dispatch('saveWidget', this.widget).then((response) => {
                this.afterSaveCallback && this.afterSaveCallback(response);
            });
        },
    },
}


// WEBPACK FOOTER //
// ./resources/js/mixins/widgetMixin.js